<template>
  <div class="loginContainer">
    <div class="login-content outer-container">
      <form @submit.prevent="importUser()" >
        <div class="wellmetrics-event-pl">WELLMETRICS EVENT PLANNER</div>
        <br/>
        <div class="subText">Create, request and schedule biometric screening events with ADURO</div>
        <div class="formInput">
          <div>
            <div class="form-title">
              Select file to import users to system.
            </div>

            <div class="row inputText">
              <div class="labelText">
                <label>Please choose file</label>
              </div>
              <div class="input-wrapper">
                <input @change="fileChange" type="file" name="file" />
                <!-- <label v-if="!getIsResetPassword">
                  <input type="email" v-model="email" class="form-control" required autofocus>
                </label>
                <label class="success-reset-password" v-if="getIsResetPassword">
                  {{email}}
                </label> -->
              </div>
            </div>
            <div class="row footerForm">
              <input type="submit" value="Upload" />
            </div>
          </div>
        </div>
      </form>
    </div>
  </div> <!-- /container -->
</template>

<script>
  import LoginHeader from './login/LoginHeader';
  import {mapActions} from 'vuex';
  export default {
    name: 'updatePassword',
    components: {
      LoginHeader
    },
    data () {
      return {
        files: null
      }
    },
    methods: {
      importUser () {
        if (this.files.length !== 0) {
          this.uploadFile(this.files[0]);
        }
      },
      fileChange (event) {
        this.files = event.target.files || event.dataTransfer.files;
      },
      ...mapActions({uploadFile: 'ACTION_UPLOAD_FILE'})
    }
  };
</script>


<style lang="less" scoped>
  @import '../../styles/variables.less';

  .loginContainer {
    height: 100vh;
    background-color: @blue;

    .login-content {
      position: absolute;
      top: 25%;
      left: 30%;
    }
    .wellmetrics-event-pl {
      height: 29px;
      color: @white;
      font-family: @font-family-title;
      font-size: 27px;
      font-weight: bold;
      width: 100%;
      text-align: center;
    }

    .labelText {
      margin-top: 10px;
      width: 30%;
    }
    .subText {
      font-family: @font-family-title;
      font-size: 14px;
      color: @white;
      width: 100%;
      text-align: center;
      margin-bottom: 10px;
    }

    .formInput {
      background-color: @white;
      height: 255px;
      width: 575px;
      border-radius: 5px;
      padding: 55px 50px 35px 50px;
      margin: auto;
      .form-title {
        font-family: @font-family-main;
        font-size: 12px;
        font-weight: bold;
        padding: 0;
      }
    }

    .inputText {
      margin: 25px 0 0 0;
      .input-wrapper {
        width: 70%;
        label {
          width: 100%;
        }
      }
    }

    .submitButton {
      float: right;
      margin-top: 15px;
      background-color: @blue;
      color: @white;
    }

    .btn-reset-password {
      float: right;
      margin-top: 15px;
      background-color: @blue;
      color: @white;
      padding: 7px 25px 10px 25px;
    }

    .forgotPassword {
      margin-top: 20px;
    }

    .loginContainer {
      height: 100%;
    }

    .form-signin {
      padding: 15px;
      margin: 0 auto;
    }

    .footerForm {
      margin-top: 25px;
    }

    .form-signin .form-signin-heading,
    .form-signin .checkbox {
      margin-bottom: 10px;
      text-align: center;
      margin-top: 20px;
    }
    .form-signin .checkbox {
      font-weight: normal;
    }
    .form-signin .form-control {
      position: relative;
      height: auto;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      font-size: 16px;
      border-radius: 5px;
      background-color: @white;
    }
    .form-signin .form-control:focus {
      z-index: 2;
    }

    .success-reset-password {
      padding-top: 10px;
    }

  }
</style>




// WEBPACK FOOTER //
// ImportUser.vue?3ce514cd